import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VDialog,{attrs:{"value":_vm.value || _vm.upsellDialog.creatorsClub,"max-width":_vm.maxWidth,"persistent":_vm.persistent,"overlay-opacity":"0.8"},on:{"input":_vm.onDialogInput},scopedSlots:_vm._u([{key:"activator",fn:function(props){return [_vm._t("activator",null,null,props)]}}],null,true)},[_c('creators-club-promo-banner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }